<template>
    <div class="navbar-start">
        <template v-if="links">
            <!-- games -->
            <div class="navbar-list">
                <router-link
                    v-for="link in links"
                    :key="link.name"
                    class="navbar-item"
                    :class="{ crash: link.name === 'crash' && isJantaBets }"
                    :to="link.route"
                    >{{ link.text | translate }}</router-link
                >
            </div>
        </template>
    </div>
</template>
<script>
import Vue from 'vue';

import menuHelper from '../../../helpers/menu.helper';
import priorityNav from 'priority-nav';

export default {
    name: 'topbar-start',
    data() {
        return {
            links: null
        };
    },
    async mounted() {
        this.links = await menuHelper.getMenuLinks();
        this.init();
    },
    computed: {
        client() {
            return Vue.state.client.get();
        },
        clientAlias() {
            return this.client && this.client.view && this.client.view.general && this.client.view.general.alias;
        },
        isJantaBets() {
            return this.clientAlias === 'Jantabets';
        }
    },
    methods: {
        async init() {
            await this.$nextTick();
            this.initResponseMenu();
        },
        initResponseMenu() {
            const nav = priorityNav.init({
                mainNavWrapper: '.navbar-start',
                mainNav: '.navbar-list',
                navDropdownLabel:
                    '<svg width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M0 0h6v6H0zM8 0h6v6H8zM8 8h6v6H8zM0 8h6v6H0z"/></svg> ' +
                    Vue.i18n.translate('components.common.topbar.more'),
                navDropdownClassName: 'navbar-dropdown',
                navDropdownToggleClassName: 'navbar-dropdown-toggle',
                breakPoint: 0
            });
        }
    }
};
</script>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/topbar/topbar-start.vue